import type { CompleteOrganizationOnboardingDto } from '@cmoh/shared'
import { useQuery } from '@tanstack/react-query'
import { unwrapApi } from '@/hooks/use-api'
import { api } from '@/lib/axios'

/**
 * Hook to get organization company data.
 * Fetches existing company information for the organization.
 */
export function useGetCompanyData(organizationId: string) {
  return useQuery({
    queryKey: ['organization', organizationId, 'company-data'],
    queryFn: async () => {
      console.log('[useGetCompanyData] Fetching company data', {
        organizationId,
      })

      const response = await api.get<CompleteOrganizationOnboardingDto>(
        `/organization/${organizationId}/company-data`,
      )

      const data = unwrapApi(response)

      console.log('[useGetCompanyData] Company data fetched', data)

      return data
    },
    enabled: Boolean(organizationId),
  })
}
